import type { StartPeriod } from '@/src/renderer/lib/db/models'
import { PERIOD_RANGES } from '../../utils/parseStartDate'

export function isToday(date: Date): boolean {
  const now = new Date()
  return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()
}

export function isTomorrow(date: Date): boolean {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return date.getFullYear() === tomorrow.getFullYear() && date.getMonth() === tomorrow.getMonth() && date.getDate() === tomorrow.getDate()
}

/** Check if a period's time range has already passed today */
export function isPeriodPastToday(period: StartPeriod): boolean {
  const now = new Date()
  const [endH] = PERIOD_RANGES[period].end.split(':').map(Number)
  return now.getHours() >= endH
}

/** Get the next half-hour as "HH:MM" (e.g. 01:14 → "01:30", 01:45 → "02:00") */
export function getNextHalfHour(): string {
  const now = new Date()
  let h = now.getHours()
  let m = now.getMinutes()
  if (m < 30) {
    m = 30
  } else {
    m = 0
    h = (h + 1) % 24
  }
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

export const PERIODS: { key: StartPeriod; shortcut: string }[] = [
  { key: 'morning', shortcut: '3' },
  { key: 'noon', shortcut: '4' },
  { key: 'afternoon', shortcut: '5' },
  { key: 'evening', shortcut: '6' },
]
